import React from 'react';

import PageTemplate from '../../components/template/PageTemplate';
import { CATEGORY_PAGE_NAME } from '../../constants/service/app/categoryConstants';
import CategoryCreateWrap from '../../views/category/create/CategoryCreateWrap';

const CategoryCreate = () => {
  return (
    <PageTemplate pageName={CATEGORY_PAGE_NAME.CATEGORY_CREATE_MANAGEMENT}>
      <CategoryCreateWrap />
    </PageTemplate>
  );
};

export default CategoryCreate;
